export enum TipoParametroRequisicao {
    QUERY = "Query",
    PATH = "Path",
    BODY = "Body"
}
